import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import DashboardLayout from "@/layouts/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import MyPortal from "@/pages/MyPortal";
import Employees from "@/pages/Employees";
import Leave from "@/pages/Leave";
import Attendance from "@/pages/Attendance";
import Claims from "@/pages/Claims";
import Payroll from "@/pages/Payroll";
import Approvals from "@/pages/Approvals";
import Settings from "@/pages/Settings";
import AdminTenants from "@/pages/AdminTenants";
import PaymentSuccess from "@/pages/PaymentSuccess";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (location.state?.user) return children;
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-10 h-10 border-4 border-blue-700 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route element={<Protected><DashboardLayout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/my-portal" element={<MyPortal />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/leave" element={<Leave />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/payroll" element={<Payroll />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/admin/tenants" element={<AdminTenants />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
